import { getTimeRange } from '../../../../../../constants/helpers/dates';

import { UssdReportCreateForm } from './interfaces';

export const mapTableDataIntoApiFormat = (report: UssdReportCreateForm) => ({
  name: report.name,
  metadata: {
    timeRange: getTimeRange({ from: report.from, to: report.to }),
    shortcodes: report.shortcodes,
    msisdns: report.msisdns,
    operators: report.operators,
    operationIds: report.operationIds,
    sessionTypes: report.sessionTypes,
    sessionTags: report.sessionTags,
    sessionCloseReasons: report.sessionCloseReasons
  }
});
